import * as React from 'react'
import { cn } from '@/utilities/cn'
import { Link } from '@/components/Link'

export interface EmptyStateProps {
  emoji?: string
  title: string
  message?: string
  action?: { label: string; href: string }
  className?: string
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  emoji,
  title,
  message,
  action,
  className,
}) => {
  return (
    <div className={cn('text-center py-16', className)} role="status">
      {emoji ? <div className="text-6xl mb-4" aria-hidden="true">{emoji}</div> : null}
      <h2 className="text-2xl font-kadwa font-semibold text-slate-700 mb-2">{title}</h2>
      {message ? <p className="text-slate-600">{message}</p> : null}
      {action ? (
        <div className="mt-6">
          <Link href={action.href}>{action.label}</Link>
        </div>
      ) : null}
    </div>
  )
}

export default EmptyState
